export default "__VITE_ASSET__3ede50a8__"